import { useState } from 'react';

import { PathwayUser, Plan } from '@cfa/pathway-fe-shared/xp';

import { DueDatePopUp } from '@/components/popups/DueDatePopUp';
import { PathwayModal } from '@/components/popups/PathwayModal';

import TeamMembersStep from './TeamMembersStep';

export interface AssignTeamMembersModalProps {
  isOpen: boolean;
  onClose: () => void;
  plan?: Plan;
  isCompliance?: boolean;
  reassignEligible?: boolean;
  teamMemberQueryOptions?: Record<string, unknown>;
  onAssign: (userIds: string[], dueDate: string | null) => void;
}

const AssignTeamMembersModal: React.FC<AssignTeamMembersModalProps> = ({
  isOpen,
  onClose,
  plan,
  isCompliance,
  reassignEligible,
  teamMemberQueryOptions,
  onAssign,
}) => {
  const [step, setStep] = useState<'team-members' | 'due-date'>('team-members');
  const [pendingUserIds, setPendingUserIds] = useState<string[]>([]);

  const handleClose = () => {
    setStep('team-members');
    setPendingUserIds([]);
    onClose();
  };

  const handleTeamMembersNext = (selectedTeamMembers: PathwayUser[]) => {
    const userIds = selectedTeamMembers
      .map(member => member.adId)
      .filter((adId): adId is string => !!adId);

    if (isCompliance) {
      const offset = plan?.dueDateOffsetInDays ?? 0;
      const withOffset = new Date();
      withOffset.setDate(withOffset.getDate() + offset);
      onAssign(userIds, withOffset.toISOString());
      handleClose();
      return;
    }
    setPendingUserIds(userIds);
    setStep('due-date');
  };

  const handleDueDateSave = (dueDate: string | null) => {
    onAssign(pendingUserIds, dueDate);
    handleClose();
  };

  return (
    <PathwayModal
      isOpen={isOpen}
      onClose={handleClose}
      className={
        step === 'team-members' ? 'lg:max-w-[840px]!' : '2xl:max-w-[610px]!'
      }
      stepKey={step}
    >
      {step === 'team-members' && (
        <TeamMembersStep
          isOpen={isOpen}
          onClose={handleClose}
          plan={plan}
          isCompliance={isCompliance}
          reassignEligible={reassignEligible}
          teamMemberQueryOptions={teamMemberQueryOptions}
          onNext={handleTeamMembersNext}
        />
      )}
      {step === 'due-date' && (
        <DueDatePopUp
          isStep
          onSave={handleDueDateSave}
          onBack={() => setStep('team-members')}
        />
      )}
    </PathwayModal>
  );
};

export default AssignTeamMembersModal;
